import { 
  collection, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  doc, 
  getDocs, 
  getDoc, 
  query, 
  where 
} from 'firebase/firestore';
import { db } from '../firebase';
import { FloorPlan } from '../types';

// Collection reference
const planCollection = 'venuePlans';

// Save a new venue plan
export const savePlan = async (uid: string, plan: FloorPlan): Promise<string> => {
  const docRef = await addDoc(collection(db, planCollection), {
    ...plan,
    userId: uid,
    createdAt: new Date(),
    updatedAt: new Date()
  });
  return docRef.id;
};

// Update an existing plan
export const updatePlan = async (planId: string, plan: Partial<FloorPlan>): Promise<void> => {
  const planRef = doc(db, planCollection, planId);
  await updateDoc(planRef, {
    ...plan,
    updatedAt: new Date()
  });
};

// Delete a plan
export const deletePlan = async (planId: string): Promise<void> => {
  const planRef = doc(db, planCollection, planId);
  await deleteDoc(planRef);
};

// Get all plans for a user
export const getUserPlans = async (uid: string): Promise<FloorPlan[]> => {
  const plansQuery = query(collection(db, planCollection), where('userId', '==', uid));
  const querySnapshot = await getDocs(plansQuery);
  
  const plans: FloorPlan[] = [];
  querySnapshot.forEach((doc) => {
    const planData = doc.data() as FloorPlan;
    plans.push({
      ...planData,
      id: doc.id
    });
  });
  
  return plans;
};

// Get a specific plan
export const getPlanById = async (planId: string): Promise<FloorPlan | null> => {
  const planRef = doc(db, planCollection, planId);
  const planSnap = await getDoc(planRef);
  
  if (planSnap.exists()) {
    const planData = planSnap.data() as FloorPlan;
    return {
      ...planData,
      id: planSnap.id
    };
  }
  
  return null;
}; 